import { cn } from 'ethcss'
import React from 'react'
import styles from '../uploader.styles.jcss'
import translate from 'core/translate'
import { grid } from 'theme'
import Button from 'blocks.simple/button/button'
import { TEMPLATE_FILES_TYPES } from '../constant'
import { useTypedSelector } from 'core/store/hooks'
import { IUserState } from 'blocks.app/user/user.state'

const SampleSection = ({ actionType, isCsv }: { actionType: TEMPLATE_FILES_TYPES | null; isCsv: boolean }) => {
    const { tokens } = useTypedSelector<IUserState>((state) => state.user)

    if (!actionType) return null

    const getFileName = (type: string) => {
        switch (type) {
            case 'selectFromFile':
                return 'devicesSelectList'
            case 'ipTv':
                return 'iptv'
            case 'wineCatalog':
                return 'wineCatalog'
            case 'menuProductCatalog':
                return 'menuProductCatalog'
            case 'teachersCatalog':
                return 'teachersCatalog'
            case 'schoolSchedule':
                return 'schoolSchedule'
            case 'commonFavouriteLinksCatalog':
                return 'commonFavouriteLinksCatalog'
            case 'coursesCatalog':
                return 'coursesCatalog'
            case 'classroomsCatalog':
                return 'classroomsCatalog'
            case 'gradesCatalog':
                return 'gradesCatalog'
            case 'subjectsCatalog':
                return 'subjectsCatalog'
        }
    }

    const getSample = async () => {
        if (!tokens?.accessToken) return
        const response = await fetch(`${window.spconfig.ip_address}v2/download/templates?page=${actionType}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${tokens?.accessToken}`,
            },
        })

        if (response && response.ok) {
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `${getFileName(actionType)}${isCsv ? '.csv' : '.xlsx'}`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        }
    }

    return (
        <div className={cn(styles.section, styles.sampleFileSection, grid.mt_miniPlus, grid.mb_miniPlus)}>
            <div className={styles.hint}>{translate('sampleFileHint')}</div>
            <Button className={styles.uploadBtn} mod={'withShadow'} onClick={getSample}>
                {translate('downloadSampleFile')}
            </Button>
        </div>
    )
}

export default SampleSection
